import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=15483333&scoped=true"
import script from "./top-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./top-bar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./top-bar.vue?vue&type=style&index=0&id=15483333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15483333",
  null
  
)

export default component.exports